export const HEADLINE = "Great,";
export const TITLE = "Together";
export const TELL_US = "Tell us about your project and we’ll be in touch";
export const OPTIONS = ["UI/UX", "Web Development", "App Development", "Consultant"];